import * as React from 'react';
import { useInstantSearch } from 'react-instantsearch';
import { useIntl } from '@grandvisionhq/state';
import { NoResults } from '../NoResults/NoResults.js';
import { SearchResultsContent } from './SearchResultsContent.js';

const ConnectedContentListing = ()=>{
    const { results: { nbHits , hits , query  } ,  } = useInstantSearch();
    const { getLabel  } = useIntl();
    const suggestions = nbHits > 0 ? hits : [];
    if (nbHits === 0) {
        return /*#__PURE__*/ React.createElement(NoResults, {
            title: getLabel('search.noResults.title'),
            description: getLabel('search.noResults.text'),
            query: query
        });
    }
    return /*#__PURE__*/ React.createElement(SearchResultsContent, {
        results: suggestions
    });
};

export { ConnectedContentListing };
//# sourceMappingURL=ConnectedResultsContent.js.map
